import React from 'react';
import { createRoot } from 'react-dom/client';

import { SchoolSuspend } from '../main-app/components/SchoolSuspend';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('react-school-suspend');

  if (node) {
    const root = createRoot(node);
    root.render(<SchoolSuspend />);
  }
});
